import { render, staticRenderFns } from "./gerenciarVoucherRetirado.vue?vue&type=template&id=8fdcf97a"
import script from "./gerenciarVoucherRetirado.vue?vue&type=script&lang=js"
export * from "./gerenciarVoucherRetirado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports